import { useFormContext, useWatch } from 'react-hook-form';

import { useEffect, useMemo } from 'react';
import { filterPillText, useModelFilterField } from '../../../form';
import { useModelFiltersContext } from '@rhino-project/core/hooks';
import { FilterFloat } from '../../../Filter';

const FLOAT_INCREMENT = 0.000000000000001;

export const ModelFilterFloat = ({
  path,
  ...props
}: {
  path: string;
  [key: string]: unknown;
}) => {
  const { attribute, operator, operatorPath, ...rest } =
    useModelFilterField(path);
  const { resetField } = useFormContext();

  const min = useMemo(() => {
    if (attribute.exclusiveMinimum) return attribute.minimum! + FLOAT_INCREMENT;

    return attribute.minimum;
  }, [attribute]);
  const max = useMemo(() => {
    if (attribute.exclusiveMaximum) return attribute.maximum! - FLOAT_INCREMENT;

    return attribute.maximum;
  }, [attribute]);

  const watch = useWatch({ name: operatorPath });

  const { setPill } = useModelFiltersContext();

  // If the user clears the input, we want to reset the pill
  useEffect(() => {
    if (watch !== undefined && watch !== '')
      setPill(operatorPath, filterPillText(attribute, operator, watch));
  }, [attribute, operator, operatorPath, resetField, setPill, watch]);

  return (
    <FilterFloat path={operatorPath} min={min} max={max} {...rest} {...props} />
  );
};
